module.exports = __webpack_public_path__ + "static/img/活动图_画板 1.3b23164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/活动图_画板 1.png
// module id = Avzi
// module chunks = 16